import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { TableText, CommonText } from "styledComponents/common";

import Bean from "../../assets/img/icons/delete_normal.svg";
import Pencil from "../../assets/img/icons/edit-2.svg";
import audioIcon from "../../assets/img/icons/play-icon.svg";
import TaskActionTooltip from "../../components/Tooltip/TaskActionTooltip";
import ToggleButton from "../../components/ToggleButton/ToggleButton";
import { CommonFlexIcon, CommonImage } from "../../styledComponents/common";
import {
  LineItemTableHeaderContainer,
  LineItemTableRowContainer,
} from "../Jobs/CreateJob/createTaskStyles";
import { IconButtonHolder } from "../Jobs/tasksStyles";
import { currencySymbolMap } from '../../utils/currencies';
import {
  EvidenceIcon,
  EvidenceIconSection,
} from "../Jobs/JobApproval/taskApprovalStyle";
import lineItemTableIcon from "../../assets/img/icons/line_item_table_icon.svg";
const { TableItem } = require("styledComponents/teams");

const LineItemsTable = ({
  itemArray,
  onEditItem,
  onDeleteItem,
  totalCalc = "0.00",
  currency = { value: "USD" },
  isDetailView: isDetailViewProp,
  onImageClick,
  onAudioClick,
  getDuration,
  pageName = "other",
  pageType = "other",
  onTax1ToggleClick,
  onTax2ToggleClick,
}) => {
  const isDetailView = isDetailViewProp !== undefined ? isDetailViewProp : (!onEditItem && !onDeleteItem);
  const { t } = useTranslation();
  const [selectIndex, setSelectIndex] = useState(-1);
  const [toolTip, setToolTip] = useState(-1);

  const pageNameMap = {
  "approval": "16px 10px minmax(50px, 2fr) minmax(30px,70px) 70px 100px 100px 70px minmax(80px, 1fr)",
  "other": "16px 10px minmax(50px, 2fr) minmax(30px,70px) minmax(50px, 2fr) 70px 100px 100px 70px minmax(80px, 1fr)",
  "invoice": "16px 10px minmax(50px, 2fr) minmax(30px,70px) minmax(50px, 2fr) 70px 70px 70px 100px 100px minmax(80px, 1fr)"
}

  const gridColumns = pageType === "invoice" ? pageNameMap["invoice"] : pageNameMap[pageName];

  const toolTipChange = (value, index) => {
    setToolTip(value);
    setSelectIndex(index);
  };

  const handleDelete = index => {
    if (onDeleteItem) {
      onDeleteItem(index);
    }
  };

  const handleEdit = index => {
    if (onEditItem) {
      onEditItem(index);
    }
  };

  return (
    <div style={{ width: "100%", overflowX: "None" }}>
      <LineItemTableHeaderContainer columns={gridColumns}>
        <TableItem>
          <TableText></TableText>
        </TableItem>
        <TableItem>
          <TableText>#</TableText>
        </TableItem>
        <TableItem>
          <TableText>Name</TableText>
        </TableItem>
        <TableItem>
          <TableText>Item Type</TableText>
        </TableItem>
        {pageName !== "approval" && <TableItem>
          <TableText>Description</TableText>
        </TableItem>}
        <TableItem>
          <TableText>Quantity</TableText>
        </TableItem>
        {pageType === "invoice" && (
          <>
            <TableItem>
              <TableText>Tax 1</TableText>
            </TableItem>
            <TableItem>
              <TableText>Tax 2</TableText>
            </TableItem>
          </>
        )}
        <TableItem>
          <TableText>Unit Price</TableText>
        </TableItem>
        <TableItem>
          <TableText>Amount</TableText>
        </TableItem>
        {pageType !== "invoice" && (
          <TableItem>
            <TableText>Evidence</TableText>
          </TableItem>
        )}
        {isDetailView ? (
          <TableItem>
            <TableText>Files</TableText>
          </TableItem>
        ) : (
          <TableItem>
            <TableText>Actions</TableText>
          </TableItem>
        )}
      </LineItemTableHeaderContainer>

      {itemArray.map((item, index) => (
        <LineItemTableRowContainer
          columns={gridColumns}
          key={index}
        //   isLastItem={index === itemArray.length - 1}
        isLastItem={false}
        >
          <TableItem>
          <TableText><CommonImage src={lineItemTableIcon} alt="icon" /></TableText>
        </TableItem>
          <TableItem>
            <TableText>{index + 1}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{item.name}</TableText>
          </TableItem>
          <TableItem>
            <TableText>{item.itemType}</TableText>
          </TableItem>
          {pageName !== "approval" && <TableItem>
            <TableText>{item.description || "-"}</TableText>
          </TableItem>}
          <TableItem>
            <TableText>{item.quantity !== undefined && item.quantity !== null
                  ? item.quantity
                  : '-'}</TableText>
          </TableItem>
          {pageType === "invoice" && (
            <>
              <TableItem>
                <ToggleButton
                  active={item.tax1Toggle}
                  handleClick={() => onTax1ToggleClick && onTax1ToggleClick(index)}
                  margin={"0 auto"}
                />
              </TableItem>
              <TableItem>
                <ToggleButton
                  active={item.tax2Toggle}
                  handleClick={() => onTax2ToggleClick && onTax2ToggleClick(index)}
                  margin={"0 auto"}
                />
              </TableItem>
            </>
          )}
          <TableItem>
            <TableText>{item.unitPrice
                  ? `${currencySymbolMap[currency?.value || currency] || ''} ${item.unitPrice}`
                  : '-'}</TableText>
          </TableItem>
          <TableItem>
            <TableText fontWeight="bold" >
              {item.amount
                  ? `${currencySymbolMap[currency?.value || currency] || ''} ${item.amount}`
                  : '-'}
            </TableText>
          </TableItem>
          {pageType !== "invoice" && (
            <TableItem>
              <TableText>{item.evidenceToggle ? "Yes" : "No"}</TableText>
            </TableItem>
          )}
          {isDetailView ? (
            <TableItem>
              <EvidenceIconSection>
                {item.evidences &&
                  item.evidences.length > 0 &&
                  item.evidences.map((evidence, evIndex) => (
                    <Fragment
                      key={`lineitem-${item.id || index}-evidence-${evidence.id || evIndex}`}
                    >
                      {evidence.image && (
                        <EvidenceIcon
                          onClick={() =>
                            onImageClick && onImageClick(evidence.image)
                          }
                        >
                          <CommonImage
                            src={evidence.image}
                            alt="img"
                          />
                        </EvidenceIcon>
                      )}
                      {evidence.audio && (
                        <EvidenceIcon
                          onClick={() =>
                            onAudioClick && onAudioClick(evidence.audio)
                          }
                        >
                          <CommonImage
                            src={audioIcon}
                            alt=""
                          />
                          {getDuration && (
                            <span
                              style={{
                                fontSize: "10px",
                                color: "#2266EF",
                                fontWeight: "600",
                              }}
                            >
                              {getDuration(evidence.audio)}
                            </span>
                          )}
                        </EvidenceIcon>
                      )}
                    </Fragment>
                  ))}
                {(!item.evidences ||
                  item.evidences.length === 0) && (
                  <CommonText fontSize="12px">-</CommonText>
                )}
              </EvidenceIconSection>
            </TableItem>
          ) : (
            <TableItem>
              <CommonFlexIcon gap="0px">
                <IconButtonHolder
                  onMouseEnter={() => toolTipChange(1, index)}
                  onMouseLeave={() => toolTipChange(-1)}
                  onClick={() => handleEdit(index)}
                >
                  <CommonImage src={Pencil} alt="pencil" size="24px" />
                  {selectIndex === index && toolTip === 1 && (
                    <TaskActionTooltip toolTipText={t("edit")} />
                  )}
                </IconButtonHolder>
                <IconButtonHolder
                  onMouseEnter={() => toolTipChange(3, index)}
                  onMouseLeave={() => toolTipChange(-1)}
                  onClick={() => handleDelete(index)}
                >
                  <CommonImage src={Bean} alt="" size="24px" />
                  {selectIndex === index && toolTip === 3 && (
                    <TaskActionTooltip toolTipText={t("delete")} />
                  )}
                </IconButtonHolder>
              </CommonFlexIcon>
            </TableItem>
          )}
        </LineItemTableRowContainer>
      ))}

      {itemArray?.length > 0 && (
        <LineItemTableRowContainer columns={gridColumns}>
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText />
          </TableItem>
          {pageName !== "approval" && <TableItem>
            <TableText />
          </TableItem>}
          <TableItem>
            <TableText />
          </TableItem>
          {pageType === "invoice" && (
            <>
              <TableItem>
                <TableText />
              </TableItem>
              <TableItem>
                <TableText />
              </TableItem>
            </>
          )}
          <TableItem>
            <TableText />
          </TableItem>
          <TableItem>
            <TableText name fontWeight="bold" > Total </TableText>
          </TableItem>
          <TableItem>
            <TableText name color="#2266EF" fontWeight="bold" >
              {currencySymbolMap[currency?.value || currency] || ''} {totalCalc}
            </TableText>
          </TableItem>
          {pageType !== "invoice" && (
            <TableItem>
              <TableText />
            </TableItem>
          )}
          <TableItem>
            <TableText />
          </TableItem>
        </LineItemTableRowContainer>
      )}
    </div>
  );
};

export default LineItemsTable;
